(function () {
  function isMobile() {
    return window.matchMedia('(max-width: 600px)').matches;
  }

  function bindToggles() {
    document.querySelectorAll('[data-collapse-toggle]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function (e) {
        if (!isMobile()) return;
        const col = btn.closest('.fgk__col--collapsible');
        if (!col) return;
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      });
    });
  }

  function syncForViewport() {
    document.querySelectorAll('[data-collapse-toggle]').forEach(function (btn) {
      if (!isMobile()) {
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindToggles();
      syncForViewport();
    });
  } else {
    bindToggles();
    syncForViewport();
  }

  window.addEventListener('resize', syncForViewport);
})();
